"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _constants = require("../../../static/constants");

var _icons = require("../../../static/icons/icons");

var _Picture = _interopRequireDefault(require("../../atoms/Picture"));

var _style = require("./style");

var Footer = function Footer(_ref) {
  var changeLanguageText = _ref.changeLanguageText,
      links = _ref.links,
      rightsReservedText = _ref.rightsReservedText,
      onClickLanguage = _ref.onClickLanguage;

  var onIconClick = function onIconClick(item) {
    return function () {
      window.open(_constants.constants["".concat(item, "_URL")], '_blank');
    };
  };

  return _react["default"].createElement(_style.Container, {
    id: "footer"
  }, _react["default"].createElement(_style.LinksContainer, null, _react["default"].createElement(_style.Column, null, links.map(function (link) {
    return _react["default"].createElement(_style.Links, {
      key: link.title
    }, _react["default"].createElement(_style.Title, null, link.title), link.items.map(function (_ref2) {
      var text = _ref2.text,
          href = _ref2.href;
      return _react["default"].createElement(_style.LinkItem, {
        key: text,
        href: href
      }, text);
    }));
  })), _react["default"].createElement(_style.Column, null, _react["default"].createElement(_style.Links, null, _react["default"].createElement(_style.Language, {
    onClick: onClickLanguage
  }, changeLanguageText), _react["default"].createElement(_style.Icons, null, _react["default"].createElement(_style.IconStyled, {
    color: _palette.palette.grey,
    handleClick: onIconClick('TWITTER'),
    icon: _icons.ICONS.TWITTER
  }), _react["default"].createElement(_style.IconStyled, {
    color: _palette.palette.grey,
    handleClick: onIconClick('FACEBOOK'),
    icon: _icons.ICONS.FACEBOOK
  }), _react["default"].createElement(_style.IconStyled, {
    color: _palette.palette.grey,
    handleClick: onIconClick('INSTAGRAM'),
    icon: _icons.ICONS.INSTAGRAM
  }), _react["default"].createElement(_style.IconStyled, {
    color: _palette.palette.grey,
    handleClick: onIconClick('LINKEDIN'),
    icon: _icons.ICONS.LINKEDIN
  })), _react["default"].createElement(_style.Copyright, null, "Bob.io \xA9", ' ', new Date().getFullYear()), _react["default"].createElement(_style.RightsReserved, null, rightsReservedText)))), _react["default"].createElement(_style.Row, null, _react["default"].createElement(_style.FirstPicture, null, _react["default"].createElement(_Picture["default"], {
    image: "https://bob.io/wp-content/uploads/footer.png",
    alt: "BoB.io"
  })), _react["default"].createElement(_style.SecondPicture, null, _react["default"].createElement(_Picture["default"], {
    image: "https://bob.io/wp-content/uploads/footer2.png",
    alt: "BoB.io"
  }))));
};

Footer.propTypes = {
  changeLanguageText: _propTypes["default"].string,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  rightsReservedText: _propTypes["default"].string,
  onClickLanguage: _propTypes["default"].func
};
Footer.defaultProps = {
  changeLanguageText: 'Cambiar a castellano',
  links: [{
    title: 'ABOUT',
    items: [{
      text: 'Privacy',
      href: '/privacy'
    }, {
      text: 'Conditions',
      href: '/conditions'
    }]
  }, {
    title: 'CONTACT',
    items: [{
      text: 'Jobs',
      href: 'https://angel.co/bob-io/jobs'
    }, {
      text: 'Help',
      href: 'https://help.bob.io/category/ayuda-en-espanol/'
    }]
  }],
  onClickLanguage: function onClickLanguage() {
    return console.log('language switcher');
  },
  rightsReservedText: 'All rights reserved'
};
var _default = Footer;
exports["default"] = _default;